import { APICore } from "./apiCore";

const api = new APICore();

const getAgendamentoColaborador = ((queryString?: string) => {
    return api.get(`/agendamento-colaborador${queryString ? queryString : ""}`)
})

export { getAgendamentoColaborador };